<template>
  <v-col cols="12">
    <v-row
      v-if="display"
      justify="start"
    >
      <v-row
        justify="start"
        align="center"
        class="py-4"
      >
        <v-col
          v-for="(image, idx) in documents"
          :key="`image-${idx}-${image.id}`"
          style="margin-top: 16px;"
          class="image-col"
        >
          <span>{{ getCategoryName(image.category) }}</span>
          <p>Envio: {{ formateDate(image.createdDate) }}</p>
          <analysis-image-modal
            :value="image"
            :documents="prepareDocuments"
          />
        </v-col>
      </v-row>
    </v-row>
    <v-row
      v-else
      justify="center"
      align="center"
      class="pt-6 pb-9"
    >
      <v-col
        v-if="!isLoading"
        cols="4"
      >
        <span>Usuário ainda não fez upload de algum documento</span>
      </v-col>
      <v-col
        v-else
        cols="12"
      >
        <v-row>
          <v-col cols="3">
            <skeleton
              width="100"
              height="150"
            />
          </v-col>
          <v-col cols="3">
            <skeleton
              width="100"
              height="150"
            />
          </v-col>
          <v-col cols="3">
            <skeleton
              width="100"
              height="150"
            />
          </v-col>
          <v-col cols="3">
            <skeleton
              width="100"
              height="150"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-col>
</template>

<script>
import ArchivesTypes from '@/app/arch/enums/ArchivesTypes';
import Moment from 'moment';
import AnalysisImageModal from '../modals/AnalysisImageModal.vue';

export default {
  name: 'ClientDocumentImages',
  components: { AnalysisImageModal },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
    },
  },
  data: () => ({
    categories: ArchivesTypes,
  }),
  computed: {
    documents() {
      return this.value;
    },
    display() {
      return this.documents && this.documents.length >= 1;
    },
    isLoading() {
      return this.loading;
    },
    getCategoryName() {
      return (type) => {
        const category = this.categories.find(
          (c) => c.value === type,
        );
        return category ? category.text : type;
      };
    },
    prepareDocuments() {
      return this.documents.map(
        (document) => ({
          ...document,
          category: this.getCategoryName(document.category),
        }),
      );
    },
    formateDate() {
      return (date) => {
        if (!date) return date;
        return Moment(date).format('DD/MM/YYYY');
      };
    },
  },
};
</script>

<style scoped>
.image-col:hover{
  background-color: rgb(226, 226, 226);
}
</style>
